<div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <input
      #searchInput
      [placeholder]="'searchBox.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      [attr.tabindex]="getTabIndex(isMobile | async)"
      [attr.aria-label]="'searchBox.placeholder' | cxTranslate"
      (click)="search(searchInput.value)"
      (input)="search(searchInput.value)"
      (blur)="close()"
      (keydown.tab)="close()"
      (keydown.escape)="close()"
      (keydown.enter)="close(true); launchSearchResult(searchInput.value); updateChosenWord(searchInput.value)"
      (keydown.arrowup)="focusPreviousChild($any($event))"
      (keydown.arrowdown)="focusNextChild($any($event))"
      value="{{ chosenWord }}"
    />

    <button
      [attr.aria-label]="'common.reset' | cxTranslate"
      [title]="'common.reset' | cxTranslate"
      (click)="clear(searchInput)"
      class="reset"
    >
      <cx-icon [type]="iconTypes.RESET"></cx-icon>
    </button>

    <div role="presentation" class="search-icon" [title]="'common.search' | cxTranslate">
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </div>

    <button
      #searchButton
      [attr.aria-label]="'common.search' | cxTranslate"
      [title]="'common.search' | cxTranslate"
      class="search"
      (click)="open()"
    >
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </label>
</div>

<div *ngIf="results$ | async as result" class="results" id="results" (click)="close(true)">
  <h3 *ngIf="result.message" [innerHTML]="result.message"></h3>

  <!--RESULT SUGGESTIONS-->
  <div class="suggestions" *ngIf="(searchInputEl?.nativeElement?.value ?? '').length > 0">
    <ul tabindex="0" attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}" role="listbox">
      <li *ngFor="let suggestion of result.suggestions" role="option">
        <a
          role="option"
          [innerHTML]="suggestion | cxHighlight: searchInputEl?.nativeElement?.value"
          [routerLink]="
            {
              cxRoute: 'search',
              params: { query: suggestion },
            } | cxUrl
          "
          (keydown.arrowup)="focusPreviousChild($any($event))"
          (keydown.arrowdown)="focusNextChild($any($event))"
          (keydown.enter)="close(true)"
          (keydown.escape)="close(true)"
          (blur)="close()"
          (mousedown)="preventDefault($event)"
          (click)="
            dispatchSuggestionEvent({
              freeText: searchInputEl?.nativeElement?.value,
              selectedSuggestion: suggestion,
              searchSuggestions: result.suggestions ?? [],
            });
            updateChosenWord(suggestion)
          "
        >
        </a>
      </li>
    </ul>
  </div>

  <!-- TRENDING SEARCHES -->
  <!--
  <div class="trending-searches-container" [class.d-block]="searchInputEl?.nativeElement?.value?.length === 0">
    <ng-container *ngIf="searchBoxFeatures.TRENDING_SEARCHES_FEATURE">
      <ng-container *cxFeature="searchBoxFeatures.TRENDING_SEARCHES_FEATURE">
        <ng-template
          [cxOutlet]="searchBoxOutlets.TRENDING_SEARCHES"
          [cxOutletContext]="{
            maxTrendingSearches: config.maxTrendingSearches,
          }"
        ></ng-template>
      </ng-container>
    </ng-container>
  </div>
  -->

  <!-- RECENT SEARCHES -->
  <!--
  <ng-template
    *ngIf="config.recentSearches"
    [cxOutlet]="searchBoxOutlets.RECENT_SEARCHES"
    [cxOutletContext]="{
      search: searchInputEl?.nativeElement?.value ?? '',
      searchBoxActive: searchBoxActive,
      maxRecentSearches: config.maxRecentSearches,
    }"
  ></ng-template>
  -->

  <!--RESULT  PRODUCTS-->
  <div class="products">
    <!---
    <ng-container
      *ngIf="
        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||
        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)
      "
    >
      <h3 *ngIf="result.products?.length">
        {{ 'searchBox.products' | cxTranslate }}
      </h3>
    </ng-container>
    -->
    <ul *ngIf="result.products" attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}" role="listbox">
      <li *ngFor="let product of result.products" role="option">
        <a
          role="option"
          [routerLink]="
            {
              cxRoute: 'product',
              params: product,
            } | cxUrl
          "
          [class.has-media]="config.displayProductImages"
          (keydown.arrowup)="focusPreviousChild($any($event))"
          (keydown.arrowdown)="focusNextChild($any($event))"
          (keydown.enter)="close(true)"
          (keydown.escape)="close(true)"
          (blur)="close()"
          (mousedown)="preventDefault($event)"
          (click)="
            dispatchProductEvent({
              freeText: searchInputEl?.nativeElement?.value,
              productCode: product.code,
            })
          "
        >
          <cx-media
            *ngIf="config.displayProductImages"
            [container]="product.images?.PRIMARY"
            format="thumbnail"
            role="presentation"
          ></cx-media>
          <div class="name" [innerHTML]="product.mainCategoryName + ' ' + product.modelMark || product.modelMark"></div>
          <span *ngIf="showPrice" class="price">{{ product.price?.formattedValue }}</span>
        </a>
      </li>
    </ul>
    <!--
    <ng-container *ngIf="items$ | async as items">
      <cx-carousel
        role="region"
        [items]="items"
        [template]="carouselItem"
        itemWidth="160px"
        (keybordEvent)="carouselEventPropagator($event)"
      >
      </cx-carousel>

      <ng-template #carouselItem let-product="item">
        <a
          tabindex="0"
          [routerLink]="
            {
              cxRoute: 'product',
              params: product,
            } | cxUrl
          "
          [class.has-media]="config.displayProductImages"
          (keydown.enter)="close(true)"
          (keydown.escape)="close(true)"
          (keydown.arrowup)="carouselEventPropagator($any($event))"
          (mousedown)="preventDefault($event)"
          (click)="
            dispatchProductEvent({
              freeText: searchInputEl?.nativeElement?.value,
              productCode: product.code,
            })
          "
        >
          <cx-media
            tabindex="0"
            [container]="product.images?.PRIMARY"
            format="product"
            [alt]="product.name ?? ''"
          ></cx-media>
          <h3 class="cx-product-name" [innerHtml]="product.nameHtml"></h3>
          <div class="price">
            {{ product.price?.formattedValue }}
          </div>
        </a>
        <div class="actions">
          <ng-container cxInnerComponentsHost></ng-container>
        </div>
      </ng-template>
    </ng-container>
    -->
  </div>

  <span id="initialDescription" class="cx-visually-hidden">
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </span>
  <div *ngIf="result.suggestions?.length || result.products?.length" aria-live="assertive" class="cx-visually-hidden">
    {{ 'searchBox.suggestionsResult' | cxTranslate: { count: result.suggestions?.length } }}
    {{ 'searchBox.productsResult' | cxTranslate: { count: result.products?.length } }}
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </div>
</div>
